<div class="pbw">
  <!--
    Una sola cabecera, y compacta.

    Eran dos tarjetas blancas apiladas sobre el gris del layout —una para el título y la tira de
    pasos, otra para el paso— dentro de un modal que ya es una tarjeta: tres marcos para un
    contenido. Y la cabecera se comía media pantalla útil antes del primer dato: un título de
    1.5rem, una tira de pasos de 5rem de alto y un botón «✕ Salir» con etiqueta donde el resto de
    los modales de la plataforma pone una X.
  -->
  <header class="pbw-head">
    <span class="pbw-icon" aria-hidden="true"><i class="fa-solid fa-file-arrow-up"></i></span>

    <div class="pbw-head-text">
      <h2>Carga de pagos</h2>
      <p>Sube la hoja, revisa lo que trae y decide si solo se registran o si además se aplican a los arrendamientos.</p>
    </div>

    <button type="button" class="pbw-close" (click)="salir()" aria-label="Cerrar el asistente">
      <i class="fa-solid fa-xmark" aria-hidden="true"></i>
    </button>

    <!--
      La tira de pasos, propia y no `p-steps`.

      La de PrimeNG pinta seis enlaces de 2rem con su etiqueta debajo y deja todo pulsable, aunque
      la mitad de los saltos estén prohibidos. Aquí el paso al que no se puede ir sale deshabilitado
      —la misma regla que aplica `onStepClick`, preguntada con `puedeIr`— y el hilo entre pasos se
      oscurece conforme se avanza, así que la tira dice a la vez dónde estoy y cuánto falta.

      El clic se traduce a CLAVE con la lista visible: los pasos son tres o seis según el
      interruptor, así que un índice significa cosas distintas según el modo.
    -->
    <ol class="pbw-rail" aria-label="Pasos de la carga">
      <li *ngFor="let s of steps; let i = index" class="pbw-step"
        [class.is-done]="i < activeIndex" [class.is-now]="i === activeIndex">
        <button type="button" class="pbw-step-btn" [disabled]="!puedeIr(i)" (click)="onStepClick(i)"
          [attr.aria-current]="i === activeIndex ? 'step' : null"
          [attr.aria-label]="'Paso ' + (i + 1) + ' de ' + steps.length + ': ' + s.label">
          <span class="pbw-step-n" aria-hidden="true">
            <i class="fa-solid fa-check" *ngIf="i < activeIndex"></i>
            <ng-container *ngIf="i >= activeIndex">{{ i + 1 }}</ng-container>
          </span>
          <span class="pbw-step-l">{{ s.label }}</span>
        </button>
      </li>
    </ol>
  </header>

  <div class="pbw-body">
    <section class="pbw-panel" *ngIf="loading">
      <div class="pbw-loading">
        <i class="fa-solid fa-spinner fa-spin"></i>
        <span>Recuperando el lote…</span>
      </div>
    </section>

    <section class="pbw-panel" *ngIf="loadError">
      <div class="pbw-error">
        <i class="fa-solid fa-triangle-exclamation" aria-hidden="true"></i>
        <div>
          <p class="pbw-error-t">No se pudo recuperar este lote</p>
          <p class="pbw-error-b">{{ loadError }}</p>
        </div>
        <button pButton type="button" label="Empezar uno nuevo" class="p-button-outlined" routerLink="/cobranza/lote"></button>
      </div>
    </section>

    <!-- Un componente por paso, elegido por CLAVE. -->
    <ng-container *ngIf="!loading && !loadError">
      <app-step1-archivo *ngIf="activeKey === 'archivo'" (onDone)="onStepDone()" (onExit)="salir()"></app-step1-archivo>
      <app-step2-revision *ngIf="activeKey === 'revision'" (onDone)="onStepDone()" (onBack)="onBack()" (onModeChange)="onModeChange()" (onRegistered)="onBatchCreated()" (onExit)="salir()"></app-step2-revision>
      <app-step3-registro *ngIf="activeKey === 'registro'" (onDone)="onStepDone()" (onExit)="salir()"></app-step3-registro>
      <app-step4-destinos *ngIf="activeKey === 'destinos'" (onDone)="onStepDone()" (onBack)="onBack()" (onExit)="salir()"></app-step4-destinos>
      <app-step5-impacto *ngIf="activeKey === 'impacto'" (onDone)="onStepDone()" (onBack)="onBack()" (onExit)="salir()"></app-step5-impacto>
      <app-step6-aplicacion *ngIf="activeKey === 'aplicacion'" (onBack)="onBack()" (onExit)="salir()"></app-step6-aplicacion>
    </ng-container>
  </div>
</div>

<p-toast position="top-right"></p-toast>
